import { render, staticRenderFns } from "./create.vue?vue&type=template&id=56b5642d"
import script from "./js/create.js?vue&type=script&lang=js&external"
export * from "./js/create.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports